import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { MigrationControllerApi } from "../services";
import {
  DGT_Pagination,
  getConfigObject,
  useBaseContent,
} from "../utils/utils";
import { GridSortItem } from "@mui/x-data-grid";

interface UseGetDataImportProps {
  dataImportUuid: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  xTENANTID?: string;
  searchString?: string;
  enabled: boolean;
}

/**
 * @author rajkumar rathod
 */
const useProviderImportList = ({
  gridSorting,
  pagination,
  xTENANTID,
  dataImportUuid,
  enabled,
  searchString,
}: UseGetDataImportProps): useBaseContent<any> => {
  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    enabled: enabled,
    queryKey: [
      "data-import-patient",
      pagination,
      dataImportUuid,
      xTENANTID,
      searchString,
      gridSorting,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new MigrationControllerApi(getConfigObject())
        .getImportedProviderData(
          dataImportUuid,
          pagination.page,
          pagination.pageSize,
          sortBy, // sortBy
          sortDirect, // sortDirection
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
export default useProviderImportList;
